import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { ReauthDialog } from "@/components/ReauthDialog";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      {children}
      <ReauthDialog />
      <Toaster />
    </ThemeProvider>
  );
}
